import React, { useEffect, useRef, useState } from "react";
import translate from "../../../i18n/translate";
import "./WelcomeForm.scss";
import CustomTextField from "../../shared/FormComponents/CustomTextField";
import CustomSelect from "../../shared/FormComponents/CustomSelect";
import CustomRadioGroup from "../../shared/FormComponents/CustomRadioGroup";
import intlTelInput from "intl-tel-input";
import "intl-tel-input/build/js/utils";
import "../../../intlTelInput.css";
import {
  Button,
  Checkbox,
  CircularProgress,
  FormHelperText,
  IconButton,
  InputAdornment,
  Snackbar,
  Typography,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { useIntl } from "react-intl";
import { openTermsWindow } from "../../shared/LearnerProfile/termsWindow";
import countryList from "./../../../data/CountryList/CountryList.json";
import cityCountryMappingData from "./../../../data/CountryList/CityCountryMapping.json";
import { timeZoneCountryMappingData } from "../../../data/CountryList/TimeZoneCountryMapping";
import { useSelector, useDispatch } from "react-redux";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import { LOCALES, showContactOptionalProduct } from "../../../globalConstants";
import { API, graphqlOperation } from "aws-amplify";
import { SetLearnerInfoPeople, UpdateNewPasswordPeople } from "../../../queries";
import allActions from "../../../redux/actions";
import Alert from "@material-ui/lab/Alert";
import { useNavigate, useLocation } from "react-router-dom";
import EditSharpIcon from "@material-ui/icons/EditSharp";
import ChangePasswordPopup from "./utils/ChangePasswordPopup";
import {
  disabledEditFunctionality,
  getAlertColors,
  getSupportLanguage,
  openPrivacy,
  radioList,
  URLButton,
  useStyles,
  validateOptions,
} from "./utils/WelcomeUtils";
import ProfileFooter from "./utils/ProfileFooter";

interface CountryState {
  val: string;
  key: string;
  countryISDCode: string;
  updated: number;
}
function WelcomeForm() {
  const location = useLocation();
  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();
  const allInfo = useSelector((state: any) => state);
  const telRef = useRef<any>(null);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [lgId, setLgId] = useState("");
  const [selectCountry, setSelectCountry] = useState<CountryState>({
    val: "",
    key: "",
    countryISDCode: "",
    updated: 123456,
  });
  const [selectTImeZone, setSelectTImeZone] = useState("");
  const [selectPhoneOrEmail, setSelectPhoneOrEmail] = useState("");
  const [number, setNumber] = useState("");
  const [showPassWord, setShowPassWord] = useState(true);
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [continueLoading, setContinueLoading] = useState(false);
  const [selectedSupportLanguage, setSelectedSupportLanguage] = useState({
    key: "",
    val: "",
  });
  const [showOptionalNumber, setShowOptionalNumber] = useState(false);
  const [toastOptions, setToastOptions] = useState({
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "message_errorDefault",
  });
  const [error, setError] = useState({
    firstName: "",
    lastName: "",
    preferredContact: "",
    contactNumber: "",
    createPassword: "",
    confirmPassword: "",
    supportLanguage: "",
    acceptTerms: "",
  });
  const navigate = useNavigate();
  const timeZone = getGmtCode();
  const currentCountry = selectCountry || getCurrentCountry();
  const [profileForm, setProfileForm] = useState({
    isProfileForm: false,
    changePasswordSection: false,
    ShowChangePasswordPopup: false,
  });
  const [showPreferContact, setShowPreferContact] = useState(false);
  const [pageName, setPageName] = useState("");
  const [passwordUpdateFlag, setPasswordUpdateFlag] = useState("");
  const [openFooter, setOpenFooter] = useState(false);
  const [dialCode, setDialCode] = useState("");
  const userPrimaryInputArray = [
    {
      id: "firstName",
      aria: "profile_fnamePlaceholder",
      placeholder: "First name * ",
      label: "",
      inputProps: {
        maxLength: 255,
        pattern: `^[a-zA-Z0-9 _'"\\-\\.#&;,]+$`,
      },
      name: "firstName",
      fullWidth: true,
      required: true,
      variant: "outlined",
      state: firstName,
      setState: setFirstName,
      errorMessage: error.firstName,
      endAdornment: allInfo?.peopleInformation?.isLoading ? (
        <CircularProgress color="primary" className="circularLoader"></CircularProgress>
      ) : null,
      isDisabled: profileForm.isProfileForm,
    },
    {
      id: "lastName",
      aria: "profile_lnamePlaceholder",
      placeholder: "Last name *",
      label: "",
      inputProps: {
        maxLength: 255,
        pattern: `^[a-zA-Z0-9 _'"\\-\\.#&;,]+$`,
      },
      name: "lastName",
      fullWidth: true,
      required: true,
      variant: "outlined",
      state: lastName,
      setState: setLastName,
      errorMessage: error.lastName,
      isDisabled: profileForm.isProfileForm,
      endAdornment: allInfo?.peopleInformation?.isLoading ? (
        <CircularProgress color="primary" className="circularLoader"></CircularProgress>
      ) : null,
    },
    {
      id: "emailId",
      aria: "profile_managerEmailPlaceholder",
      placeholder: "Email * ",
      label: "",
      inputProps: {
        maxLength: 255,
        pattern: `^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$`,
      },
      name: "email",
      fullWidth: true,
      required: true,
      variant: "outlined",
      state: email,
      setState: setEmail,
      isDisabled: true,
      endAdornment: allInfo?.peopleInformation?.isLoading ? (
        <CircularProgress color="primary" className="circularLoader"></CircularProgress>
      ) : (
        <InputAdornment position="end">
          <Button type="button" className="verified_color" variant="contained" color="primary" disabled={true}>
            <CheckCircleOutlineIcon className="tick_Mark"></CheckCircleOutlineIcon>
            <Typography className="lbl_verified_color normalFont">{translate("profile_emailVerifiedChip")}</Typography>
          </Button>
        </InputAdornment>
      ),
    },
  ];
  const CountryTimeZoneArray = [
    {
      id: "country",
      label: "Country *",
      name: "prof_country",
      aria: "profile_countryPlaceholder",
      menuList: countryList,
      setState: setSelectCountry,
      defaultValue: currentCountry,
      infoText: "Select country *",
      isDisabled: profileForm.isProfileForm,
    },
    {
      id: "timeZone",
      label: "Time Zone *",
      value: selectTImeZone,
      name: "prof_time",
      aria: "",
      menuList: timeZoneCountryMappingData,
      defaultValue: timeZone,
      setState: setSelectTImeZone,
      placeholder: "Select time zone",
      infoText: "Select time zone *",
      isDisabled: profileForm.isProfileForm,
    },
  ];
  const passwordList = [
    {
      id: "newPassword",
      autoComplete: "off",
      aria: "profile_changepass_newpasswordPlaceholder",
      placeholder: "Create Password *",
      label: "",
      name: "password",
      fullWidth: true,
      required: true,
      variant: "outlined",
      errorMessage: error.createPassword,
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            className={newPassword === "" ? "diasabled-passview-icon" : "passview-icon"}
            disabled={newPassword === ""}
            aria-label="toggle password visibility"
            onClick={() => {
              toggleViewPassword();
            }}
            data-testid="toggle-password-button"
          >
            {showPassWord ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      ),
    },
    {
      id: "confirmNewPassword",
      aria: "profile_changepass_confirmnewpassword",
      placeholder: "Confirm Password *",
      label: "",
      name: "confirmPassword",
      fullWidth: true,
      required: true,
      variant: "outlined",
      errorMessage: error.confirmPassword,
    },
  ];
  useEffect(() => {
    const initializeIntlTelInput = (elementId: string,initialCode:string) => {
      const inputElement = document.getElementById(elementId) as HTMLElement;
      const telInput = intlTelInput(inputElement, {
        allowDropdown: !profileForm.isProfileForm,
        initialCountry: initialCode,
        separateDialCode: true,
        placeholderNumberType: "FIXED_LINE_OR_MOBILE",
        utilsScript: "/node_modules/intl-tel-input/build/js/utils.js?1711489147110",
      });
      inputElement.addEventListener("countrychange", () => {
        const country = telInput.getSelectedCountryData();
        setDialCode(country.dialCode);
      });
      return telInput;
    };
    if ((showOptionalNumber && selectPhoneOrEmail === "email" ) || selectPhoneOrEmail === "mobile") {
    const initialCode =  fetchCountryDialCode()
      const elementId = selectPhoneOrEmail === "email" ? "contact_number_email" : "contact_number";
      if (telRef.current) {
        telRef.current.destroy();
      }
      telRef.current = initializeIntlTelInput(elementId,initialCode);
    }
    return () => {
      if (telRef.current) {
        telRef.current.destroy();
        telRef.current = null;
      }
    };
  }, [showOptionalNumber, selectPhoneOrEmail, profileForm.isProfileForm]);
  useEffect(() => {
    fetchUserData();
  }, [allInfo.peopleInformation]);
  useEffect(() => {
    if (!confirmNewPassword.includes(newPassword) && newPassword !== "" && confirmNewPassword !== "") {
      setError({
        ...error,
        confirmPassword: "Confirm password should match create password",
      });
    } else {
      setError({
        ...error,
        confirmPassword: "",
      });
    }
  }, [confirmNewPassword, newPassword]);
  useEffect(() => {
    if (selectPhoneOrEmail !== "") {
      setError({
        ...error,
        preferredContact: "",
      });
    }
  }, [selectPhoneOrEmail]);
  useEffect(() => {
    if (location.pathname === "/profile") {
      setProfileForm((prevState) => ({
        ...prevState,
        isProfileForm: true,
        changePasswordSection: true,
      }));
      setPageName("profile");
    } else {
      setProfileForm((prevState) => ({
        ...prevState,
        isProfileForm: false,
        changePasswordSection: false,
      }));
      setPageName("welcome");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (passwordUpdateFlag === "success") {
      setToastOptions({
        toastOpen: true,
        toastSeverity: "success",
        toastMessageKey: "message_successUpdated",
      });
    } else if (passwordUpdateFlag === "error") {
      setToastOptions({
        toastOpen: true,
        toastSeverity: "error",
        toastMessageKey: "message_errorDefault",
      });
    }
  }, [passwordUpdateFlag]);

  useEffect(() => {
    const SelectedTimeZone = currentTime(selectCountry.key);
    setSelectTImeZone(SelectedTimeZone ?? "");
  }, [selectCountry]);
  useEffect(() => {
    visibleContactPreference(allInfo?.peopleInformation?.data?.getpeopleInformation?.contactPreference);
  }, [profileForm.isProfileForm]);

  const toggleViewPassword = () => {
    setShowPassWord(!showPassWord);
  };
  const handleTermsCondition = (event: React.ChangeEvent<HTMLInputElement>) => {
    setAcceptTerms(event.target.checked);
  };
  const handleSubmitting = () => {
    const data = {
      firstName: firstName,
      lastName: lastName,
      newPassword: newPassword,
      pageName: pageName,
      confirmNewPassword: confirmNewPassword,
      selectedSupportLanguage: selectedSupportLanguage.val,
      acceptTerms: acceptTerms,
      selectPhoneOrEmail: selectPhoneOrEmail,
      number: number,
    };
    const validation = validateOptions(data);
    setError(validation);
    const isValid = Object.values(validation).every((error) => error === "");
    if (isValid && pageName !== "profile") {
      updateWelcomeInfo();
    } else if (isValid && pageName === "profile") {
      updateProfileInfo();
    }
  };
  function getCurrentCountry() {
    if (timeZone) {
      const captureCityName = timeZone.split("/");
      const cityName = captureCityName[captureCityName.length - 1];
      const currentCountryName = cityCountryMappingData[cityName as keyof typeof cityCountryMappingData] || null;
      const CurrentCountryData = countryList.find((obj) => obj.key === currentCountryName);
      return CurrentCountryData;
    }
  }
  const fetchUserData = () => {
    if (!allInfo?.peopleInformation?.isLoading) {
      const peopleInfo = allInfo?.peopleInformation?.data?.getpeopleInformation || {};
      const commonInfo = allInfo?.common || {}; 
      setFirstName(peopleInfo.firstName);
      setLastName(peopleInfo.lastName);
      setEmail(peopleInfo.email);
      visibleContactPreference(peopleInfo.contactPreference);
      setLgId(commonInfo.lgId);
    
      const languagePreference = getSupportLanguage(peopleInfo.language);
      const currentCountry = countryList.find(
        (obj) => obj.val === peopleInfo.country
      );
      setSelectCountry(currentCountry || selectCountry);
      setSelectedSupportLanguage(languagePreference || { key: "English", val: "EN" });
      peopleInfo.license?.forEach((product: { productId: string; }) => {
        if (showContactOptionalProduct.includes(product.productId)) {
          setShowOptionalNumber(true);
        }
      });
    }   
  };
  function getGmtCode() {
    const currentZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const validateTimeZone = currentZone === "Asia/Calcutta" ? 'Asia/Kolkata' : currentZone   // browser doesn't provide Asia/Kolkata .So hard corder this part
    const foundZoneWithGMT = timeZoneCountryMappingData.find((element) => element.includes(validateTimeZone));
    return selectTImeZone || foundZoneWithGMT;
  }
  function currentTime(country: string) {
    if (country) {
      const currentCity = Object.entries(cityCountryMappingData).find(([_, value]) => value === country);
      const timeZone = currentCity ? currentCity[0] : "";
      const foundZoneWithGMT = timeZoneCountryMappingData.find((element) => element.includes(timeZone));
      return foundZoneWithGMT;
    }
  }

  async function updateWelcomeInfo() {
    setContinueLoading(true);
    const formatProfileData = getProfileDetails();

    const passWordData = API.graphql(
      graphqlOperation(UpdateNewPasswordPeople(lgId, confirmNewPassword)),
    ) as Promise<any>;
    passWordData
      .then(async () => {
        dispatch(
          allActions.updatePeopleInformationAction.setStorePeopleInfo(
            lgId,
            formatProfileData,
            selectedSupportLanguage.val,
          ),
        );
        setToastOptions({
          toastOpen: true,
          toastSeverity: "success",
          toastMessageKey: "message_successUpdated",
        });
        setTimeout(() => {
          navigate("/");
        }, 2500);
      })
      .catch(() => {
        setToastOptions({
          toastOpen: true,
          toastSeverity: "error",
          toastMessageKey: "message_errorDefault",
        });
      });
    setContinueLoading(false);
  }
  async function updateProfileInfo() {
    setContinueLoading(true);
    const formatProfileData = getProfileDetails();
    const setPeopleInfoHandle = API.graphql(
      graphqlOperation(SetLearnerInfoPeople(lgId, formatProfileData, selectedSupportLanguage.val)),
    ) as Promise<any>;
    await setPeopleInfoHandle
      .then((peopleData: any) => {
        if (peopleData?.data) {
          setToastOptions({
            toastOpen: true,
            toastSeverity: "success",
            toastMessageKey: "message_successUpdated",
          });
          setTimeout(() => {
            window.location.reload();
          }, 2500);
        }
      })
      .catch((e) => {
        console.log(e);
      });
    setContinueLoading(false);
  }
  function getProfileDetails() {
    const phone1Prefix = dialCode !== "" ? dialCode : currentCountry.countryISDCode;
    return pageName !== "profile"
      ? {
          firstName: firstName,
          lastName: lastName,
          email: email,
          country: currentCountry.val,
          contactPreference: selectPhoneOrEmail,
          phone1: number.trim() === "" ? "-" : number,
          tos: acceptTerms,
        }
      : {
          firstName: firstName,
          lastName: lastName,
          email: email,
          country: currentCountry.val,
          contactPreference: selectPhoneOrEmail,
          phone1:
          number.trim() === "" ? "-" : `${phone1Prefix}-${number}`,
        };
  }
  const toastCloseHandler = () => {
    setToastOptions({
      toastOpen: false,
      toastSeverity: "success",
      toastMessageKey: "message_successUpdated",
    });
  };

  const visibleContactPreference = (preference: string) => {
    if (pageName !== "welcome" && preference === "" && profileForm.isProfileForm) {
      setShowPreferContact(false);
    } else {
      if (pageName === "profile") {
        const updatedPreference = preference === 'phone' ? 'mobile': preference;
        setSelectPhoneOrEmail(updatedPreference);
        const { phone1, phone2 } = allInfo?.peopleInformation?.data?.getpeopleInformation || {};
        const phoneToParse = [phone1, phone2].find(phone => phone && phone !== "-") || "";
        const phoneNumber = parsePhoneNumber(phoneToParse);
        setNumber(phoneNumber);
      }
      setShowPreferContact(true);
    }
  };

  function disableSubmitButton() {
    const info = allInfo?.peopleInformation?.data?.getpeopleInformation;
    const data = {
      firstName: firstName,
      lastName: lastName,
      selectCountry: selectCountry.val,
      selectPhoneOrEmail: selectPhoneOrEmail,
      selectedSupportLanguage: selectedSupportLanguage.val,
      number: number === "" ? "-" : number,
    };
    const editFunctionality = disabledEditFunctionality(info, data);
    if (pageName === "profile") {
      return continueLoading ? true : editFunctionality;
    } else {
      return continueLoading;
    }
  }
  function parsePhoneNumber(phoneNumber: string): string {
   
    const parts = phoneNumber?.split("-");

    if ( parts.length ===2) {
      setDialCode(parts[0]);
      return parts.slice(1).join("");
    } else {
      return phoneNumber;
    }
  }
  function fetchCountryDialCode() {   
    const countryCode = countryList.find((obj) => obj.countryISDCode === dialCode);
    return countryCode?.val  === undefined  ? selectCountry?.val : countryCode?.val;
  }

  const buttonLabel = pageName === "welcome" ? translate("button_continue") : translate("profile_updateLabel");

  return (
    <div className="profile_container">
      <div className="pageHeaderCover">
        <h1 className="pageHeadText">
          {pageName === "profile" ? "My Profile" : translate("profile_welcomeJumbotron")}
        </h1>
      </div>
      <div className={`profile_form_container ${pageName}`}>
        <div className="preButtonContainer">
          {profileForm.isProfileForm && (
            <div className="editButtonCover">
              <Button
                onClick={() =>
                  setProfileForm((prevState) => ({
                    ...prevState,
                    isProfileForm: false,
                  }))
                }
                aria-label={`${intl.formatMessage({ id: "profile_editAria" })}`}
                size="small"
                className={classes.editButton}
                startIcon={<EditSharpIcon />}
              >
                {translate("profile_editLabel")}
              </Button>
            </div>
          )}
        </div>
        {userPrimaryInputArray.map((input: any) => (
          <CustomTextField
            id={input.id}
            aria={input.aria}
            placeholder={input.placeholder}
            inputProps={input.inputProps}
            fullWidth={input.fullWidth}
            name={input.name}
            state={input.state}
            setState={input.setState}
            key={input.id}
            variant={input.variant}
            hideText={false}
            isDisabled={input?.isDisabled}
            endAdornment={input.endAdornment}
            helperText={input.errorMessage}
            data-testid={input.name}
            label={input.placeholder}
          />
        ))}
        {CountryTimeZoneArray.map((select: any) => (
          <CustomSelect
            id={select.id}
            value={select.value}
            name={select.name}
            menuList={select.menuList}
            setState={select.setState}
            key={select.id}
            defaultValue={select.defaultValue}
            infoText={select.infoText}
            disabled={select.isDisabled}
            label={select.label}
            loading={allInfo?.peopleInformation?.isLoading}
          />
        ))}
        {showPreferContact && (
          <CustomRadioGroup
            radioList={radioList}
            value={selectPhoneOrEmail}
            setValue={setSelectPhoneOrEmail}
            header={"Preferred contact *"}
            error={error.preferredContact}
            disabled={profileForm.isProfileForm}
          />
        )}
        {selectPhoneOrEmail !== "" && (
          <div>
            {showOptionalNumber && selectPhoneOrEmail === "email" && (
              <div className="contact_number">
                <CustomTextField
                  id={"contact_number_email"}
                  aria={"prof_email"}
                  placeholder={"Contact number (optional)"}
                  state={number}
                  setState={setNumber}
                  variant="outlined"
                  isDisabled={profileForm.isProfileForm}
                  label=""
                />
              </div>
            )}
            {selectPhoneOrEmail === "mobile" && (
              <div className="contact_number">
                <CustomTextField
                  id={"contact_number"}
                  aria={"prof_mobile"}
                  placeholder={"Contact number"}
                  state={number}
                  setState={setNumber}
                  variant="outlined"
                  isDisabled={profileForm.isProfileForm}
                  label=""
                />
              </div>
            )}
            {showOptionalNumber && selectPhoneOrEmail === "email" && (
              <FormHelperText style={{ fontWeight: "400", color: "#424242", fontSize: "14px" }}>
                {translate("welcome_Contact_number_helper_text")}
              </FormHelperText>
            )}
            {selectPhoneOrEmail === "mobile" && error.contactNumber && (
              <FormHelperText style={{ fontWeight: "400", color: "red", fontSize: "14px" }}>
                {error.contactNumber}
              </FormHelperText>
            )}
          </div>
        )}

        <CustomSelect
          id={"supportLanguages"}
          value={selectedSupportLanguage}
          name={"supportLanguages"}
          menuList={LOCALES}
          setState={setSelectedSupportLanguage}
          helperText={"Support language is the language in which we communicate with you."}
          infoText={"Support language *"}
          errorMessage={error.supportLanguage}
          data-testid={"support-language"}
          disabled={profileForm.isProfileForm}
          label={"Support language *"}
          loading={allInfo?.peopleInformation?.isLoading}
        />
        {profileForm.changePasswordSection && profileForm.isProfileForm && (
          <div>
            <Button
              variant="contained"
              onClick={() => {
                setProfileForm((prevState) => ({
                  ...prevState,
                  ShowChangePasswordPopup: true,
                }));
              }}
              className={classes.changePasswordButton}
            >
              Change Password
            </Button>
          </div>
        )}
        {!profileForm.changePasswordSection &&
          passwordList.map((item: any) => (
            <CustomTextField
              id={item.id}
              aria={item.aria}
              placeholder={item.placeholder}
              inputProps={item.inputProps}
              fullWidth={item.fullWidth}
              name={item.name}
              state={item.id === "newPassword" ? newPassword : confirmNewPassword}
              setState={item.id === "newPassword" ? setNewPassword : setConfirmNewPassword}
              autoComplete={item.autoComplete}
              key={item.id}
              variant={item.variant}
              hideText={item.id === "newPassword" ? showPassWord : true}
              endAdornment={item.endAdornment}
              helperText={item.errorMessage}
              label={item.placeholder}
            />
          ))}
        {!profileForm.isProfileForm && (
          <div className="privacy">
            {pageName !== "profile" && (
              <div>
                <div className="privacy_terms">
                  <Checkbox
                    className={classes.tosCheckbox}
                    checked={acceptTerms}
                    name="prof_acceptTOS"
                    id="prof_acceptTOS"
                    aria-label={`${intl.formatMessage({ id: "profile_TermsAria" })}`}
                    onChange={(evt) => {
                      handleTermsCondition(evt);
                    }}
                    color="primary"
                  />

                  <div className="privacy_terms_info">
                    I accept and agree to the{" "}
                    <URLButton className="privacy_terms_button" onClick={openTermsWindow}>
                      {translate("Terms_conditions")}
                    </URLButton>
                  </div>
                </div>
                {error.acceptTerms && (
                  <FormHelperText style={{ fontWeight: "400", color: "red", fontSize: "14px" }}>
                    {error.acceptTerms}
                  </FormHelperText>
                )}
              </div>
            )}
            {pageName !== "profile" && (
              <div className="privacy_terms">
                <div className="privacy_terms_info">
                  More information on the processing of your personal data can be found in the{" "}
                  <URLButton className="privacy_terms_button" onClick={openPrivacy}>
                    {translate("privacy_policy")}
                  </URLButton>
                </div>
              </div>
            )}

            <Button
              onClick={handleSubmitting}
              variant="contained"
              aria-label={`${intl.formatMessage({ id: "button_continue" })}`}
              size="large"
              color="primary"
              className={classes.continueButton}
              data-testid={"button_continue"}
              disabled={disableSubmitButton()}
            >
              {continueLoading ? (
                <span>
                  <CircularProgress
                    color="primary"
                    className="circularLoader"
                    data-testid={"loader"}
                  ></CircularProgress>
                </span>
              ) : (
                <span> {buttonLabel}</span>
              )}
            </Button>
            {pageName === "profile" && (
              <Button
                color="primary"
                variant="outlined"
                onClick={() => {
                  setProfileForm((prevState) => ({
                    ...prevState,
                    isProfileForm: true,
                  }));
                  window.location.reload();
                }}
                fullWidth
                style={{ color: "#000", height: "53px", borderRadius: "0" }}
              >
                {translate("profile_cancelLabel")}
              </Button>
            )}
          </div>
        )}
      </div>
      {pageName === "profile" && (
       <ProfileFooter 
       openFooter={openFooter}
       setOpenFooter={setOpenFooter}
       profileForm={profileForm}
       />
      )}
      <Snackbar
        open={toastOptions.toastOpen}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        autoHideDuration={2000}
        onClose={toastCloseHandler}
        style={{ ...getAlertColors(toastOptions.toastSeverity) }}
      >
        <Alert onClose={toastCloseHandler} style={{ ...getAlertColors(toastOptions.toastSeverity) }}>
          {translate(toastOptions.toastMessageKey)}
        </Alert>
      </Snackbar>
      {profileForm.changePasswordSection && profileForm.isProfileForm && (
        <ChangePasswordPopup
          open={profileForm.ShowChangePasswordPopup}
          onClose={() => {
            setProfileForm((prevState) => ({
              ...prevState,
              ShowChangePasswordPopup: false,
            }));
          }}
          setPasswordUpdateFlag={setPasswordUpdateFlag}
        />
      )}
    </div>
  );
}
export default WelcomeForm;
